import { BaseApi } from "../BaseApi";
import { AxiosResponse } from "axios";
import { ApiResult, AxiosErr } from "../Contracts/IMdels";

export class BaseModel {
  public baseApi: BaseApi = new BaseApi();
  protected RouteName: string = "";
  protected AuthState: boolean = true;

  public async getAll() {
    try {
      return await this.baseApi
        .axiosInstance(this.AuthState)
        .get(this.RouteName);
    } catch (e) {
      const error = e as AxiosErr;
      throw error.response?.data.message;
    }
  }

  public async get(id: number): Promise<AxiosResponse<ApiResult>> {
    try {
      return await this.baseApi
        .axiosInstance(this.AuthState)
        .get(`${this.RouteName}/${id}`);
    } catch (e) {
      const error = e as AxiosErr;
      throw error.response?.data.message;
    }
  }

  public async crete(model: object): Promise<AxiosResponse<ApiResult>> {
    try {
      return await this.baseApi
        .axiosInstance(this.AuthState)
        .post(this.RouteName, model);
    } catch (e) {
      const error = e as AxiosErr;
      throw error.response?.data;
    }
  }

  public async update(id: number, model: object) {
    try {
      return await this.baseApi
        .axiosInstance(this.AuthState)
        .put(`${this.RouteName}/?Id=${id}`, model);
    } catch (e) {
      const error = e as AxiosErr;
      throw error.response?.data.message;
    }
  }

  public async delete(id: number): Promise<AxiosResponse<ApiResult>> {
    try {
      return await this.baseApi
        .axiosInstance(this.AuthState)
        .delete(`${this.RouteName}/${id}`);
    } catch (e) {
      const error = e as AxiosErr;
      throw error.response?.data.message;
    }
  }
}
